import {backboneViewProperties} from "../../../decorators/backbone-properties";
import {AdvancedSearchFieldView} from "../../../search/views/advanced-search/advanced-search-field";
import {AdvancedSearchFilterView} from "../../../search/views/advanced-search/advanced-search-filter";
import {AdvancedSearchFieldModel} from "../../../search/models/advanced-search-field";
import {AdvancedSearchFilterModel} from "../../../search/models/advanced-search-filter";

@backboneViewProperties({
    tagName: "div",
    childView : AdvancedSearchFieldView
})
export class AdvancedSearchFieldsView extends Marionette.CollectionView<AdvancedSearchFieldModel, AdvancedSearchFieldView> {
    constructor(options?: Marionette.CollectionViewOptions<AdvancedSearchFieldModel>) {
        super(options);
        this.listenTo(this.collection, "change:ShowOnForm", this.render);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/advanced-search/advanced-search-fields.ts